import image2 from'./Images/resumeIcon.PNG'


export  const ResumeData =[
    {
        id:1,
        image:image2,
                },
    
]
